import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const IdNumber = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const noBranchInvolved = useWatch({ control, name: `institutionActivitiesInfo.${index1 as 0}.noBranchInvolved` })

  return (
    <Controller
      name={`institutionActivitiesInfo.${index1 as 0}.institutionActivityBranchesInfo.${index2 as 0}.idNumber`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="70. RSSD Number"
          input={(props) => <TextInput {...props} disabled={noBranchInvolved} />}
        />
      )}
    />
  )
}
